// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"32ea15d2","2":"c08b6609","3":"54daf50f","4":"5c708c96","5":"46ea9a6f","6":"05393c2d","7":"c165b86c","8":"58fb3a1d","9":"60069444","10":"c6e3c93e","11":"bb9bcac0"}[chunkId] + ".chunk.js";
};